import {getCurrentYear} from '../../utils/commons'
import GreatReviewsOnlineLogo from './logo'
import {greatReviewsOnlineStylesCA, greatReviewsOnlineStylesUS} from './styles'

const baseConfig = {
  domainName: 'greatreviewsonline' as const,
  domainType: 'picks' as const,
  siteName: 'Great Reviews Online',
  favicon: '/favicons/greatreviewsonline.png',
}

const localeConfigs = {
  us: {
    measurementId: 'G-2W7S03KF5T',
    camelCaseUrl: 'GreatReviewsOnline.com',
    logo: <GreatReviewsOnlineLogo className="size-14 shrink-0 tablet:size-10" locale="us" />,
    styles: greatReviewsOnlineStylesUS,
    title: (category: string, count: string) =>
      `Top ${count} ${category} ${getCurrentYear()} in the US | GreatReviewsOnline.com – Trusted Reviews & Smart Picks`,
    description: (category?: string, _count?: string) =>
      `At GreatReviewsOnline.com, we feature the best ${category} of ${getCurrentYear()} in the US. Read trusted reviews, expert comparisons, and buying guides that help you shop smarter and save more.`,
  },
  ca: {
    measurementId: 'G-YGRVGZKQGR',
    camelCaseUrl: 'GreatReviewsOnline.ca',
    logo: <GreatReviewsOnlineLogo className="size-14 shrink-0 tablet:size-10" locale="ca" />,
    styles: greatReviewsOnlineStylesCA,
    title: (category: string, count: string) =>
      `Top ${count} ${category} ${getCurrentYear()} in Canada | GreatReviewsOnline.ca – Expert Insights & Guides`,
    description: (category?: string, _count?: string) =>
      `GreatReviewsOnline.ca delivers expert product reviews and comparisons tailored for Canadian shoppers. Explore trusted picks, detailed insights, and the best ${category} to buy in ${getCurrentYear()}.`,
  },
}

export const createConfig = (locale: string = 'uk') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
